import React from "react";
import InstrumentChoice from "./InstrumentChoice";
import {searchForBondsUsingServer} from "../actions/searchForInstrumentsUsingServer";

const FixedIncomeInstrument = (props) => (
    <div>
            <InstrumentChoice value={ props.value }
                              onChange={ chosenSearchResult => props.onChange(instrumentAttributes(chosenSearchResult))}
                              searchForInstrument={ searchForBondsUsingServer }
                              className={props.className}
                              allowUserProvided={true} />
    </div>
);
FixedIncomeInstrument.propTypes = {
    className: React.PropTypes.string,
    onChange: React.PropTypes.func,
    value: React.PropTypes.shape({
        symbol: React.PropTypes.string,
        name: React.PropTypes.string
    })
};
FixedIncomeInstrument.defaultProps = {
    value: {
        symbol: null,
        name: null
    }
};

function instrumentAttributes(chosenSearchResult) {
    return {
        instrumentId: chosenSearchResult.asset_id,
        symbol: chosenSearchResult.isin,
        name: chosenSearchResult.name,
        recommendableType: chosenSearchResult.recommendableType,
        userProvided: !!chosenSearchResult.userProvided,
        recommendable: chosenSearchResult
    };
}

export default FixedIncomeInstrument;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/FixedIncomeInstrument.js
 **/